import styled from 'styled-components';
import { EspAccount } from 'modules/graphql/types';
import { DestructiveButton, BUTTON_SIZES } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { Body2, body2Bold } from 'ui/theme';
import { useModalsContext, useSendingPlatformsQueryContext } from '../../../../contexts';
import { useUpdateAccount } from '../../../../hooks';
import { EditEspAccountPayload } from '../../../../types';

export const TEXT = {
  ID: 'reset-default-account-modal',
  HEADER: 'Remove as default account?',
  CONFIRM_BTN: 'Remove as default',
};

const Strong = styled.span`
  ${body2Bold}
`;

type Props = {
  espAccountId: number;
};

export const ResetDefaultSenderModal = ({ espAccountId }: Props) => {
  const { hideModal } = useModalsContext();
  const { selectEspAccount } = useSendingPlatformsQueryContext();
  const { isLoading, updateAccount } = useUpdateAccount();

  const espAccount = selectEspAccount(espAccountId);

  if (!espAccount) return null;

  const onSubmit = () => {
    const { id, name, esp, truncatedApiKey } = espAccount as EspAccount;
    const payload: EditEspAccountPayload = {
      id,
      name,
      esp,
      apiKey: truncatedApiKey,
      isDefault: false,
      editApiKey: false,
    };
    updateAccount(payload);
    hideModal();
  };

  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>{TEXT.HEADER}</ModalHeader>
      <ModalBody>
        <Body2>
          This will reset your default sender account from <Strong>{espAccount.name}</Strong> to the
          system default, Iterable’s Shared Pool account.
        </Body2>
        <Body2>
          Message channels that aren’t bound to a specific sending platform will use this account to
          send messages by default. You can always change the sending account when you are creating
          a new message.
        </Body2>
      </ModalBody>
      <ModalFooter>
        <DestructiveButton isLoading={isLoading} onClick={onSubmit} size={BUTTON_SIZES.LARGE}>
          {TEXT.CONFIRM_BTN}
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
